import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useOnboardingStore } from '@/store/onboardingStore';
import { STARTER_PROMPTS } from '@/webapp/plan/scaffolds';
import { Button, Screen } from '../../ui';

/**
 * The front door, ported from src/app/(onboarding)/create.tsx. One idea in, nothing else.
 *
 * The starters are deliberately specific — "an event app" produces mush, "RSVP for a
 * birthday dinner" produces an app — so tapping one goes straight to a plan.
 */
export default function Idea() {
  const navigate = useNavigate();
  const setDescription = useOnboardingStore((s) => s.setDescription);
  const setAppPlan = useOnboardingStore((s) => s.setAppPlan);
  const stored = useOnboardingStore((s) => s.description);
  const [idea, setIdea] = useState(stored);

  const go = (text: string): void => {
    const goal = text.trim();
    if (!goal) return;
    setDescription(goal);
    // Cleared so the plan screen always starts from a scaffold built for THIS idea,
    // never a plan left over from a previous run.
    setAppPlan(null);
    navigate('/new/plan');
  };

  return (
    <Screen title="What do you want to make?">
      <p className="type-body idea-sub">
        Describe it in a line. You&rsquo;ll see the plan before anything is built.
      </p>

      <label className="type-caption field-label" htmlFor="idea">
        Describe the app you want
      </label>
      <textarea
        id="idea"
        className="field idea-input"
        value={idea}
        rows={3}
        onChange={(e) => setIdea(e.target.value)}
        placeholder="An RSVP page for my sister's baby shower…"
      />
      <Button title="Continue" onPress={() => go(idea)} disabled={idea.trim().length === 0} />

      <h2 className="type-micro section-label">Or start from one of these</h2>
      <div className="starter-grid">
        {STARTER_PROMPTS.map((s) => (
          <button
            key={s.label}
            type="button"
            className="card clay-card pressable starter"
            aria-label={`${s.label}. ${s.prompt}`}
            onClick={() => go(s.prompt)}
          >
            <span className="type-heading">{s.label}</span>
            <span className="type-caption starter-sub">{s.prompt}</span>
          </button>
        ))}
      </div>
    </Screen>
  );
}
